// extracted by mini-css-extract-plugin
export default {"wrapper":"_3f67964c","title":"_85aa959f","whiteBackground":"_3c19f536","railItems":"_6d98f0cf"};